/* Emoto — OKNO POPTÁVKY motocyklu skladem (snippets/emoto-skladovka-okno.liquid).
   30. 9. 2026 přesunuto ze sekce emoto-skladovky, aby okno sdílela i stránka detailu kusu (šablona product.kus).
   Na stránce je jedno okno [data-okno]; každé tlačítko „Chci…“ [data-chci] nese data-* kusu (snippet
   emoto-skladovka-karta) — klik okno vyplní (skryté pole poptávky + shrnutí kusu) a otevře.
   Výkon kusu od výrobce (60 / 80 k „Alpha“) se bere z nejbližšího předka s data-vykon (blok „u výrobce“ na seznamu,
   panel kusu na detailu). Po odeslání (poděkování) nebo s chybou formuláře se okno otevře samo. */
(() => {
  const okno = document.querySelector('[data-okno]');
  if (!okno || okno.dataset.hotovo) return;
  okno.dataset.hotovo = '1';
  const KLIC = 'emoto_skladovka';
  const VYKON = { 60: 'Standard 60 k', 80: '80 k „Alpha“' };
  const text = (sel, x) => { const el = okno.querySelector(sel); if (el) el.textContent = x || ''; };
  const pole = (sel, x) => { const el = okno.querySelector(sel); if (el) el.value = x || ''; };
  let vybrany = null;

  function vypln(v) {
    vybrany = v;
    const vyrobce = v.kde === 'vyrobce';
    const dva = vyrobce && !!v.cena80;
    const vk = dva && v.vykon === '80' ? '80' : '60';
    const cena = vk === '80' ? v.cena80 : v.cena60;
    const vyr = vk === '80' ? (v.vyr80 || v.vyr60) : v.vyr60;
    // kus od výrobce: výkon je volba (i bez rozdílu cen ho do poptávky napíšeme); ve Vlašimi je ve výbavě
    const vykon = vyrobce ? VYKON[vk] : '';
    const rozpis = vyr && v.dop ? 'cena výrobce ' + vyr + ' + doprava z výroby ' + v.dop + (v.dopEur ? ' (' + v.dopEur + ' €)' : '') : '';
    const vybava = (vykon ? 'Výkon: ' + vykon + '; ' : '') + (v.konfigurace || '');
    // 29. 9. 2026: akční cena kusu ve Vlašimi (z ktm-platform) — do poptávky i s původní cenou a rozpisem
    // 2. 10. 2026 večer: i u volné motorky na cestě do Vlašimi (kde 'cesta')
    const akce = v.kde !== 'vyrobce' ? (v.akce || '') : '';
    pole('[data-p-motorka]', (v.motorka || '') + (vykon ? ' · ' + vykon : ''));
    pole('[data-p-konfigurace]', vybava);
    pole('[data-p-cena]', akce
      ? akce + ' (akční cena; původně ' + cena + (rozpis ? ' = ' + rozpis : '') + ')'
      : (cena ? cena + (rozpis ? ' = ' + rozpis : '') : 'na dotaz'));
    pole('[data-p-dodani]', v.dodani);
    pole('[data-p-kus]', v.kus);
    okno.dataset.kde = v.kde || '';
    text('[data-v-kicker]', v.kde === 'vlasim' ? 'Skladem ve Vlašimi · k odběru hned'
      : v.kde === 'cesta' ? 'Na cestě do Vlašimi' : 'Skladem u výrobce');
    text('[data-v-motorka]', v.titulek || v.motorka);
    text('[data-v-cena]', akce ? akce + ' (akce, původně ' + cena + ')' : (cena || 'Cena na dotaz'));
    text('[data-v-dodani]', v.dodani ? 'Dodání ' + v.dodani : '');
    const vkBox = okno.querySelector('[data-v-vykon]');
    if (vkBox) {
      vkBox.hidden = !dva;
      vkBox.querySelectorAll('[data-v-vk]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.vVk === vk));
    }
    const uct = okno.querySelector('[data-v-uctenka]');
    if (uct) {
      uct.hidden = !rozpis;
      text('[data-v-vyr]', vyr);
      text('[data-v-dop]', v.dop);
      text('[data-v-dop-eur]', v.dopEur ? '· ' + v.dopEur + ' €' : '');
    }
    const img = okno.querySelector('[data-v-obr]');
    if (img) { img.hidden = !v.obr; if (v.obr) img.src = v.obr; }
    const ul = okno.querySelector('[data-v-vybava]');
    if (ul) {
      ul.replaceChildren(...vybava.split(/;\s*/).filter(Boolean).map((r) => {
        const li = document.createElement('li');
        const i = r.indexOf(': ');
        if (i > 0) {
          const dt = document.createElement('span');
          dt.textContent = r.slice(0, i);
          li.append(dt, document.createTextNode(r.slice(i + 2)));
        } else li.textContent = r;
        return li;
      }));
      ul.hidden = !ul.children.length;
    }
    const jinak = okno.querySelector('[data-v-jinak]');
    const odkaz = okno.querySelector('[data-v-odkaz]');
    if (jinak && odkaz) { jinak.hidden = !v.odkaz; if (v.odkaz) odkaz.href = v.odkaz; }
  }
  const uloz = (v) => { try { sessionStorage.setItem(KLIC, JSON.stringify(v)); } catch (e) { /* bez úložiště jen nepřežije chybu formuláře */ } };
  function otevri() {
    if (okno.open) return;
    if (typeof okno.showModal === 'function') okno.showModal(); else okno.setAttribute('open', '');
  }
  // tlačítko „Chci…“ → okno s poptávkou toho kusu, fokus do jména
  function kus(b) {
    const s = b.closest('[data-vykon]');
    const v = { ...b.dataset, vykon: (s && s.dataset.vykon) || '60' };
    uloz(v);
    vypln(v);
    otevri();
    const jm = okno.querySelector('input[name="contact[name]"]');
    if (jm) setTimeout(() => jm.focus(), 60);
  }
  document.querySelectorAll('[data-chci]').forEach((b) => b.addEventListener('click', () => kus(b)));
  okno.querySelectorAll('[data-v-vk]').forEach((b) => b.addEventListener('click', () => {
    if (!vybrany) return;
    const v = { ...vybrany, vykon: b.dataset.vVk };
    uloz(v);
    vypln(v);
  }));
  okno.querySelectorAll('[data-okno-zavrit]').forEach((b) => b.addEventListener('click', () => okno.close()));
  okno.addEventListener('click', (e) => { if (e.target === okno) okno.close(); });
  // po odeslání (poděkování) nebo s chybou formuláře se okno otevře samo; při chybě vrátí vybranou motorku
  if (okno.querySelector('[data-okno-hned]')) {
    if (okno.querySelector('.e-sk__chyba')) {
      try { vypln(JSON.parse(sessionStorage.getItem(KLIC) || '{}')); } catch (e) { /* nic */ }
    }
    otevri();
  }
})();
